module.exports = __webpack_public_path__ + "img/chart2.ada4b253.png";